<template>
  <div class="card-edit-panel">
    <div class="card-edit-panel-body">
      <div class="card-edit-panel-main">
        <div class="card-edit-panel-header">
          <div class="card-edit-panel-meta">
            <CardResponsibleUser
                :cardId="card.id"
                :value="card.user"
                @input="onResponsibleUserChanged"
            />
            <Tags
                module="planner"
                :cardId="card.id"
                :initialValue="card.listTag"
                urlCreateUpdate="/api/v1/planner/card/create-update-tags"
            />
          </div>
        </div>

        <div class="card-edit-panel-tabs">
          <Tabs :tabs="cardTabs">
            <template #descricao>
              <EditorHtml
                  field="description"
                  :formName="formName"
                  :maxLength="5000"
                  v-model="card.description"
              />
              <div class="card-edit-panel-description-actions">
                <Button
                    _key="btnSaveDescription"
                    type="success"
                    title="Salvar"
                    classIcon="fas fa-save"
                    size="small"
                    :loading="isLoading('btnSaveDescription')"
                    :clicked="saveDescription"
                />
              </div>
            </template>

            <template #checklist>
              <ChecklistCreateUpdateList class="card-edit-panel-checklist-margin" :genericId="card.id" @count-change="checklistCount = $event"/>
            </template>

            <template #tarefa>
              <CardJobForm :cardId="card.id" @count-change="jobCount = $event"/>
            </template>

            <template #equipe>
              <CardTeamList :cardId="card.id" @count-change="teamCount = $event"/>
            </template>

            <template #locacao>
              <CardRentLink :cardId="card.id" @count-change="rentCount = $event"/>
            </template>

            <!-- <template #despesa>
              <ExpenseList :genericId="card.id" @count-change="expenseCount = $event" />
            </template> -->


            <template #anexo>
              <FileManager :showInModal="false" source="card" :genericId="card.id"/>
            </template>
          </Tabs>
        </div>
      </div>

      <div class="card-edit-panel-side">
        <div class="card-edit-panel-side-title">
          <i class="fa-regular fa-comment"></i>
          <span>Notas</span>
          <span v-if="commentCount" class="card-edit-panel-tab-count"></span>
        </div>
        <CommentList :cardId="card.id" @count-change="commentCount = $event"/>
      </div>
    </div>
  </div>
</template>

<script>
import EditorHtml from "@/ui/forms/EditorHtml";
import Button from "@/ui/forms/Button";
import Tabs from "@/ui/layout/Tabs";

import FileManager from "@/ui/shared/file-manager/FileManager";

import Tags from "@/modules/shared/tag/components/Tags.vue";
import ChecklistCreateUpdateList from "@/modules/shared/checklist/components/ChecklistCreateUpdateList";

import CardResponsibleUser from "./CardResponsibleUser.vue";
import CommentList from "../comment/CommentCreateUpdateList.vue";
import CardJobForm from "../job/JobForm.vue";
import CardRentLink from "../rental/RentCreateLink.vue";
import ExpenseList from "@/modules/shared/expense/components/ExpenseList.vue";
import CardTeamList from "@/modules/shared/team/components/TeamList.vue";

import CardService from "../../services/card.service";

import {mapMutations, mapGetters} from "vuex";

export default {
  name: "CardEditPanel",
  components: {
    EditorHtml,
    Button,
    Tabs,
    FileManager,
    Tags,
    ChecklistCreateUpdateList,
    CardResponsibleUser,
    CommentList,
    CardJobForm,
    CardRentLink,
    ExpenseList,
    CardTeamList,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formName: "cardEditPanelForm",
      commentCount: this.card.totalComment || 0,
      checklistCount: {total: this.card.totalChecklist || 0, done: this.card.totalChecklistDone || 0},
      jobCount: this.card.totalJob || 0,
      rentCount: this.card.totalRent || 0,
      expenseCount: 0,
      teamCount: this.card.totalTeam || 0,
    };
  },
  computed: {
    ...mapGetters("user", ["hasRule"]),
    ...mapGetters("generic", ["isLoading"]),
    cardTabs() {
      const tabs = [
        { key: "descricao", title: "Descrição" },
        {
          key: "checklist",
          title: "Checklist",
          badge: this.checklistCount.total
            ? this.checklistCount.done + "/" + this.checklistCount.total
            : "",
        },
        { key: "tarefa", title: "Tarefa", badge: this.jobCount || "" },
        { key: "equipe", title: "Equipe", badge: this.teamCount || "" },
      ];
      if (this.hasRule("Rental") || this.hasRule("Operational")) {
        tabs.push({ key: "locacao", title: "Locação", badge: this.rentCount || "" });
        // tabs.push({ key: "despesa", title: "Despesa", badge: this.expenseCount || "" });
      }
      tabs.push({ key: "anexo", title: "Anexo" });
      return tabs;
    },
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "addLoading", "removeLoading"]),
    async saveDescription() {
      this.addLoading("btnSaveDescription");
      this.card.tags = [];
      await CardService.update(this.card);
      this.addEvent({name: "cardUpdated"});
      this.removeLoading(["btnSaveDescription"]);
    },
    onResponsibleUserChanged() {
      this.addEvent({name: "responsibleUserUpdated"});
    },
  },
};
</script>

<style scoped>
.card-edit-panel {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.card-edit-panel-body {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
}

.card-edit-panel-main {
  flex: 1 1 320px;
  min-width: 0;
}

.card-edit-panel-side {
  flex: 1 1 420px;
  max-width: 420px;
  min-width: 280px;
  border-left: 1px solid var(--border-color);
  padding-left: 20px;
}

.card-edit-panel-side-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.card-edit-panel-side-title i {
  font-size: 14px;
  color: var(--text-muted);
}

@media (max-width: 768px) {
  .card-edit-panel-body {
    flex-direction: column;
  }

  .card-edit-panel-side {
    flex-basis: 100%;
    max-width: 100%;
    border-left: none;
    border-top: 1px solid var(--border-color);
    padding-left: 0;
    padding-top: 16px;
    margin-top: 8px;
  }
}

.card-edit-panel-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 16px;
  margin-bottom: 6px;
}

.card-edit-panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;
  font-weight: 600;
  color: var(--text-primary);
}

.card-edit-panel-title i {
  font-size: 14px;
  color: var(--text-muted);
}

.card-edit-panel-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.card-edit-panel-description-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.card-edit-panel-tabs {
  min-height: 500px;
}

.card-edit-panel-tabs ::v-deep .tabs-panel {
  padding-top: 16px;
}

.card-edit-panel-tabs ::v-deep .card-edit-panel-checklist-margin {
  margin-top: -25px;
}
</style>
